import axios from 'axios'


const api = axios.create({
  baseURL: process.env.VUE_APP_API_PATH + '/',
  timeout: 30000,
  withCredentials: true,
})

// Intercept Response
api.interceptors.response.use(
  response => {
   
    if (parseFloat(response.headers['app-version']) > parseFloat(process.env.VUE_APP_VERSION)) {
      location.reload(true);
    }
    return response
  },
  function (error) {
    const requestUrl = error?.config?.url || "";
    const isAuthCheck = requestUrl.includes("api/is-logged-in");

    // Check if offline
    if (!error.response && error.message === 'Network Error') {
      error.offline = true;
      error.message = 'You are offline. This feature requires an internet connection.';
      return Promise.reject(error);
    }

    // Handle 503 from service worker (offline state)
    if (error.response && error.response.status === 503 && error.response.data?.error === 'offline') {
      error.offline = true;
      error.message = error.response.data.message;
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401 && !isAuthCheck) {
      localStorage.removeItem('user')
      localStorage.removeItem('token')

      if (window.location.pathname !== '/v-login') {
        window.location.href = '/v-login'
      }
    }
    return Promise.reject(error)
  }
)

//const getCurrentCompanyId = () => localStorage.getItem('current_company_id')

export default api
